module.exports = __webpack_public_path__ + "static/img/ip-left.881f88b1.png";